module.exports = __webpack_public_path__ + "img/four01.31564eb2.png";